
<template>
  <v-app>
    <v-app-bar color="#01a6e6" height="63px" app>
      <v-card-title
        class="white--text"
        style="margin-top: -5px; margin-left: -20px"
      >
        <a href="https://krungthai.com/" style="margin-top: 10px"
          ><img
            alt="Vue logo"
            class="logo"
            src="@/assets/img/ktc_horizon2.jpg"
            :width="scale(150)"
            :height="scale(63)"
        /></a>
        <p class="titletext">|</p>
        <p class="titletext" :style="{ fontSize: scale(22) + 'px' }">
          บริการนายทะเบียนหลักทรัพย์
        </p>
      </v-card-title>
    </v-app-bar>
    <v-main>
      <v-container
        fill-height
        :style="{
          width: $vuetify.breakpoint.smAndDown ? '100%' : '90%',
          padding: $vuetify.breakpoint.smAndDown ? '0' : null,
        }"
      >
        <v-row justify="center">
          <!-- <v-col> -->
          <!-- <v-sheet color="transparent"> -->
          <router-view> </router-view>
          <!-- </v-sheet> -->
          <!-- </v-col> -->
        </v-row>
      </v-container>

      <!-- <v-card id="fastMenu" v-if="!isHidden">
        <v-speed-dial
          v-model="fab"
          :bottom="true"
          :right="true"
          :direction="top"
          :open-on-hover="true"
        >
          <template v-slot:activator>
            <v-btn color="blue darken-2" dark fab>
              <v-icon v-if="fab"> mdi-close </v-icon>
              <v-icon v-else> mdi-account-circle </v-icon>
            </v-btn>
          </template>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                dark
                small
                color="green"
                v-bind="attrs"
                v-on="on"
                to="/"
              >
                <v-icon>mdi-bank</v-icon>
              </v-btn>
            </template>
            <span>Back Homepage</span>
          </v-tooltip>
        </v-speed-dial>
      </v-card> -->
    </v-main>
    <v-footer color="rgb(0,166,230,1)" app>
      <v-row justify="center" no-gutters>
        <v-divider></v-divider>
        <v-card-text class="white--text">
          <div class="row">
            <div class="cl" style="margin-top: -5px">
              <div class="itemshare circle">
                <v-icon
                  :style="{ fontSize: scale(40) + 'px' }"
                  style="margin-top: -20px"
                  color="white"
                  >mdi-phone-in-talk</v-icon
                >
              </div>
              <div class="itemshare">
                <span
                  :style="{ fontSize: scale(14) + 'px' }"
                  class="footerxfont"
                  >นายทะเบียนหลักทรัพย์</span
                >
                <br />
                <span
                  :style="{ fontSize: scale(14) + 'px' }"
                  class="footerxfont"
                  >02-298-0821-30 กด 1</span
                >
              </div>
            </div>
            <div class="cr">
              <div class="itemshare">
                <a
                  href="https://www.facebook.com/krungthaibank"
                  target="_blank"
                  title="Facebook"
                >
                  <img
                    alt="Facebook"
                    id="social-cont-fb"
                    ng-src="@/assets/img/footer/footer-fb.png"
                    src="@/assets/img/footer/footer-fb.png"
                    style="display: inline"
                    :style="{ width: scale(40) + 'px' }"
                  />
                </a>
              </div>
              <div class="itemshare">
                <a
                  href="https://www.facebook.com/krungthaibank"
                  target="_blank"
                  title="Instagram"
                >
                  <img
                    alt="Instagram"
                    id="social-cont-ig"
                    ng-src="@/assets/img/footer/footer-ig.png"
                    src="@/assets/img/footer/footer-ig.png"
                    style="display: inline"
                    :style="{ width: scale(40) + 'px' }"
                  />
                </a>
              </div>
              <div class="itemshare">
                <a
                  href="https://www.krungthai.com/th/content/line-official"
                  target="_blank"
                  title="Line"
                >
                  <img
                    alt="Line"
                    id="social-cont-ln"
                    ng-src="@/assets/img/footer/footer-ln.png"
                    src="@/assets/img/footer/footer-ln.png"
                    style="display: inline"
                    :style="{ width: scale(40) + 'px' }"
                  />
                </a>
              </div>
              <div class="itemshare">
                <a
                  href="https://twitter.com/krungthai_care"
                  target="_blank"
                  title="Twitter"
                >
                  <img
                    alt="Twitter"
                    id="social-cont-tw"
                    ng-src="@/assets/img/footer/footer-tw.png"
                    src="@/assets/img/footer/footer-tw.png"
                    style="display: inline"
                    :style="{ width: scale(40) + 'px' }"
                  />
                </a>
              </div>
              <div class="itemshare">
                <a
                  href="https://www.youtube.com/ktbcare"
                  target="_blank"
                  title="Youtube"
                >
                  <img
                    alt="Youtube"
                    id="social-cont-yt"
                    ng-src="@/assets/img/footer/footer-yt.png"
                    src="@/assets/img/footer/footer-yt.png"
                    style="display: inline"
                    :style="{ width: scale(40) + 'px' }"
                  />
                </a>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-row>
    </v-footer>
  </v-app>
</template>
<script>
export default {
  data: () => ({ isHidden: false }),
  name: "app",
  methods: {
    scale(num) {
      switch (this.$vuetify.breakpoint.name) {
        case "xs": // Small to large phone < 600px
          return (num * 60) / 100;
        case "sm": // Small to medium tablet	600px > < 960px
          return (num * 70) / 100;
        case "md": //	Large tablet to laptop	960px > < 1264px
          return (num * 90) / 100;
        case "lg": // Desktop	1264px > < 1904px
          return (num * 95) / 100;
        case "xl": // 4k and ultra-wide > 1904px
          return num;
      }
    },
  },
  computed: {
    currentRouteName() {
      if (this.$route.name == "home") {
        this.isHidden = true;
      } else {
        this.isHidden = false;
      }
    },
  },
};
</script>
<style>
main {
  /*-moz-animation-play-state: ; min-height: 100vh;
    line-height: 1.6;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;*/
  /*background-color: rgb(0, 0, 0,1) !important;*/
  font-family: "Ktcfast";
  background-image: url(assets/img/bgtest.jpg);
  /* height: 80%; */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

p {
  font-family: "Ktcfast";
  font-size: 48px;
}
@font-face {
  font-family: "Ktcfast";
  src: local("Ktcfast"),
    url(assets/font/KrungthaiFast-Bold.ttf) format("truetype");
}
/* ------------ Speed dial -------------*/
#fastMenu .v-speed-dial {
  position: absolute;
}
#fastMenu .v-btn--floating {
  position: relative;
}
/*----------------------------*/
.titletext {
  font-size: 20px;
  padding-left: 15px;
  padding-top: 8px;
  padding-bottom: 8px;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: 0px;
}

.footerx {
  min-height: 49px;
  padding-left: 59px;
  display: block;
  text-decoration: none;
}
.footerxfont {
  font-family: "Ktcfast";
  color: white;
  font-size: 16px;
  line-height: 1.5;
}
.footerxfont2 {
  font-family: "Ktcfast";
  color: white;
  font-size: 16px;
  line-height: 1;
}
.cl {
  margin-right: auto;
  /* margin-left: 10px;
  margin-top: 10px; */
}
.cl .itemshare {
  display: inline-block;
  position: relative;
  margin-left: 10px;
  margin-top: 10px;
}
.cr {
  margin-left: auto;
  /* margin-right: 10px;
  margin-top: 10px; */
}
.cr .itemshare {
  display: inline-block;
  position: relative;
  margin-right: 10px;
  margin-top: 10px;
}
</style>